import React from "react";
import { IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

interface PasswordToggleIconProps {
    visible: boolean;
    onToggle: () => void;
    password: string;
}

const PasswordToggleIcon: React.FC<PasswordToggleIconProps> = ({ visible, onToggle, password }) => {
    if (!password) return null; // Nascondi l'icona se la password è vuota

    return (
        <InputAdornment position="end">
            <IconButton
                aria-label="toggle password visibility"
                onClick={onToggle}
                edge="end"
            >
                {visible ? <VisibilityOff /> : <Visibility />}
            </IconButton>
        </InputAdornment>
    );
};

export default PasswordToggleIcon;
